import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { EstreamPanelService } from 'brain-data/service/brain-estream/estream-panel.service';
import {
  loadEstreamPanels,
  loadEstreamPanelsError,
  loadEstreamPanelsSuccess,
} from '../actions/estream-panel.action';

@Injectable()
export class EstreamPanelEffects {
  loadEstreamPanels$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadEstreamPanels),
      switchMap(() =>
        this.service.getPanels().pipe(
          map(panels => loadEstreamPanelsSuccess({ panels })),
          catchError((error: Error) => of(loadEstreamPanelsError({ error }))),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: EstreamPanelService,
  ) {}
}
